exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tarihe-gore-report-table[data-v-0e9102c2]{width:100%;margin-top:4px}.tarihe-gore-report-table>*[data-v-0e9102c2]{width:100%}", ""]);

// exports
